package api


@Suppress("ClassName")
sealed class AppType(
    val type: Int,
    val label: String,
    val image: Long,
    val key: String,
    val usableInCampaign: Boolean
) {
    data object NONE : AppType(1, "UNDEFINED", -9L, "", false)
    data object IMAGE : AppType(2, "Image", -7L, "", false)
    data object VIDEO : AppType(4, "Video", -6L, "", false)
    data object PDF : AppType(8, "Document", -4L, "", false)
    data object WWW_LINK : AppType(16, "WWW link", -3L, "", false)
    data object WWW_EMBEDDED : AppType(32, "WWW embedded", -5L, "", false)
    data object RSS : AppType(64, "Rss feed", -8L, "", false)
    data object APP_GROUP : AppType(128, "App Grpup", -13L, "", false)
    data object BALOON : AppType(256, "Balloon", -19L, "", false)
    data object QUIZ : AppType(512, "Quiz", -20L, "", false)
    data object GALLERY : AppType(1024, "Gallery", -27L, "", false)
    data object WHEEL : AppType(2048, "Wheel", -27L, "wheel", false)
    data object CAMERA : AppType(4096, "Camera", -38L, "", false)
    data object VIDEO_ALPHA_LOOP : AppType(8192, "Alpha video loop", -39L, "alpha-video", true)
    data object MAZE : AppType(16384, "Maze", -41L, "maze", true)
    data object USB_PLAYER : AppType(32768, "Usb player", -44L, "", false)
    data object KINDERGARTEN : AppType(65536, "Kindergarten", -45L, "", false)

    infix fun match(type: Int): Boolean = this.type == type

    companion object {
        val all by lazy {
            listOf(
                NONE,
                IMAGE,
                VIDEO,
                PDF,
                WWW_LINK,
                WWW_EMBEDDED,
                RSS,
                APP_GROUP,
                BALOON,
                QUIZ,
                GALLERY,
                WHEEL,
                VIDEO_ALPHA_LOOP,
                CAMERA,
                MAZE,
                USB_PLAYER,
                KINDERGARTEN
            )
        }

        operator fun get(type: Int): AppType {
            return all.firstOrNull {
                it.type == type
            } ?: NONE
        }
    }
}
